
@if(isLoading){
<div class="overlay">
  <mat-spinner></mat-spinner>
</div>
}
<h2 mat-dialog-title>{{ 'error.SessionExpiredTitle' | translate }}</h2>
    <div mat-dialog-content style="padding: 10px">
      <h6>
        {{ 'error.SessionExpiredMessage' | translate }}
      </h6>
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <mat-form-field appearance="outline" class="w-100">
          <mat-icon matPrefix>person</mat-icon>
          <input matInput placeholder="Username" formControlName="username" required />
          @if(loginForm.controls['username'].invalid && loginForm.controls['username'].touched){
          <mat-error>
            {{ 'login.usernameRequired' | translate }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-icon matPrefix>key</mat-icon>
          <input matInput [type]="hide ? 'password' : 'text'" placeholder="{{ 'login.password' | translate }}" formControlName="password" required />
          <button mat-icon-button matSuffix type="button" (click)="hide = !hide">
            <mat-icon fontSet="material-icons">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (loginForm.controls['password'].invalid && loginForm.controls['password'].touched)
          {
           <mat-error>
            {{ 'login.passwordRequired' | translate }}
          </mat-error>
          }
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions align="end" style="padding: 10px">
      <button mat-stroked-button type="button" (click)="onExit()">{{ 'sidebar.signOut' | translate }}</button>
      <button mat-flat-button color="primary" [disabled]="loginForm.invalid || isLoading" (click)="onLogin()">
          {{ 'shared.confirm' | translate }}
      </button>
    </div>
